/**
 * Microdose residency / shipping-state config (JS)
 *
 * Keep in sync with: snippets/microdose-residency-config.liquid
 *
 * =============================================================================
 * AGENT / FUTURE STATE SYSTEM
 * =============================================================================
 * Today: binary cookie md_residency = oregon | other → pack 60ct | 50ct.
 *
 * Next evolution (when a second restricted state or product gating is needed):
 * 1. Add real state codes (OR, CA, ...) — prefer cookie md_state=OR, migrate
 *    md_residency gradually or map oregon→OR / other→DEFAULT.
 * 2. Drive gate UI from `states` / `restrictedStates` below (dropdown), not
 *    hardcoded Oregon buttons in the Liquid gate snippet.
 * 3. Product eligibility via tags or metafields, e.g. ships:OR / ships:all
 *    or custom.allowed_states. Filter buy swatches, collections, and cart
 *    using `isProductEligible(product, state)`.
 * 4. Put new rules ONLY in this file + the Liquid config snippet. Call sites
 *    should use window.MicrodoseResidencyConfig helpers.
 * 5. Cart reconcile (microdose-entry-gate.js) should remove ineligible products
 *    and swap pack variants via packForResidency/packForState.
 * =============================================================================
 */
(function (global) {
  'use strict';

  var config = {
    cookieKey: 'md_residency',
    attrKey: 'md_residency',
    ageCookieKey: 'md_age_ok',
    cookieDays: 365,

    /** Restrictive default when unset / unknown (compliance-safe). */
    defaultResidency: 'oregon',

    /** Valid cookie values today. */
    knownResidencies: ['oregon', 'other'],

    /**
     * residency → Count variant option value.
     * FUTURE: stateCode → pack, or stateCode → { pack, tags }.
     */
    packByResidency: {
      oregon: '60ct',
      other: '50ct',
    },

    /** residency → total mg display label (shown next to pack size on PDP). */
    mgByResidency: {
      oregon: '120mg',
      other: '100mg',
    },

    /** Header pill labels. */
    labelByResidency: {
      oregon: 'OR',
      other: 'US',
    },

    /** Pack option values recognized on variants (20ct kept for migration). */
    packValues: ['60ct', '50ct', '20ct'],

    /**
     * FUTURE: populate for a state dropdown, e.g.
     * { code: 'OR', name: 'Oregon', residencyKey: 'oregon', pack: '60ct' }
     * Gate UI can map these to buttons/select options.
     */
    states: [
      { code: 'OR', name: 'Oregon', residencyKey: 'oregon', pack: '60ct' },
      // { code: 'CA', name: 'California', residencyKey: 'california', pack: '60ct' },
    ],

    /**
     * FUTURE: product tag prefix for eligibility, e.g. ships:OR
     * Leave null until tagging ships.
     */
    eligibilityTagPrefix: null, // e.g. 'ships:'
  };

  function normalizeResidency(value) {
    var key = String(value || '').toLowerCase();
    if (config.knownResidencies.indexOf(key) !== -1) return key;
    return config.defaultResidency;
  }

  function packForResidency(residency) {
    var key = normalizeResidency(residency);
    return config.packByResidency[key] || config.packByResidency[config.defaultResidency] || '60ct';
  }

  function mgForResidency(residency) {
    var key = normalizeResidency(residency);
    return config.mgByResidency[key] || config.mgByResidency[config.defaultResidency] || '100mg';
  }

  function labelForResidency(residency) {
    var key = normalizeResidency(residency);
    return config.labelByResidency[key] || config.labelByResidency[config.defaultResidency] || 'OR';
  }

  /**
   * FUTURE: replace with tag/metafield checks.
   * Today every product is "eligible"; pack filtering handles Count variants.
   */
  function isProductEligible(product, residency) {
    if (!config.eligibilityTagPrefix) return true;
    var key = normalizeResidency(residency);
    var state = null;
    for (var i = 0; i < config.states.length; i++) {
      if (config.states[i].residencyKey === key) {
        state = config.states[i].code;
        break;
      }
    }
    if (!state) return true;
    var tags = (product && product.tags) || [];
    var allTag = config.eligibilityTagPrefix + 'all';
    var stateTag = config.eligibilityTagPrefix + state;
    for (var t = 0; t < tags.length; t++) {
      var tag = String(tags[t]);
      if (tag === allTag || tag === stateTag) return true;
    }
    return false;
  }

  config.normalizeResidency = normalizeResidency;
  config.packForResidency = packForResidency;
  config.mgForResidency = mgForResidency;
  config.labelForResidency = labelForResidency;
  config.isProductEligible = isProductEligible;

  global.MicrodoseResidencyConfig = config;
})(typeof window !== 'undefined' ? window : this);
